// these are imported into their respective pages to determine how to render the table
// determines type of input used for each category, and the options for dropdowns

import { getDSDistance, getRealChainDelta, getUSDistance } from "../helperFunctions/chainDistanceCalcs"
import { scValidateUsAndDs } from "../helperFunctions/validateTableData"


const AGMEditSchema = {
    "Site_Name": {
        "inputType": "text",
        "title": "Site Name",
        "required":  true
    },
    "Real_Chain": {
        "inputType": "number",
        "title": "Real Chain (km)",
        "required":  true,
        "readOnlyWhenLocked": true
    },
    "Est_Chain": {
        "inputType": "number",
        "title": "Estimated Chain(km)",
        "readOnlyWhenLocked": true
    },
    "Calc_Chain": {
        "inputType": "number",
        "title": "Calculated Chain(km)",
        "disabled": true
    },
    "Real_Chain_Delta": {
        "inputType": "number",
        "title": "Real Chain Delta",
        "disabled": true,
        "calculation": (agmData, currentRow) => getRealChainDelta(agmData, currentRow)
    },
    "Verified": {
        "inputType": "dropdown",
        "options": ["Yes", "No"],
        "title": "Verified"
    },
    //must have either est or real lat/lng, but handling in validation functions
    "Est_Lat": {
        "inputType": "number",
        "title": "Estimated Latitude",
        "readOnlyWhenLocked": true
    },
    "Est_Lng": {
        "inputType": "number",
        "title": "Estimated Longitude",
        "readOnlyWhenLocked": true
    },
    "Planning_Notes": {
        "inputType": "text",
        "title": "Planning Notes"
    },
    "Real_Lat": {
        "inputType": "number",
        "title": "Real Latitude",
        "readOnlyWhenLocked": true
    },
    "Real_Lng": {
        "inputType": "number",
        "title": "Real Longitude",
        "readOnlyWhenLocked": true
    },
    "GPS_Taken": {
        "inputType": "dropdown",
        "options": ["Yes", "No"],
        "title": "GPS Taken"
    },
    "Site_Type": {
        "inputType": "dropdown",
        "options": ["AGM", "BV", "LAUNCH", "RECEIVE", "AGR", "OTHER"],
        "title": "Site Type"
    },
    "Ref_Point": {
        "inputType": "text",
        "title": "Reference Point"
    },
    "Dist_Ref_Point": {
        "inputType": "number",
        "title": "Dist Ref Point"
    },
    "Site_Notes": {
        "inputType": "text",
        "title": "Site Notes"
    },
    "Address": {
        "inputType": "text",
        "title": "Address"
    },
    "Access_Notes": {
        "inputType": "text",
        "title": "Access Notes"
    },
    "Chain_Quality": {
        "inputType": "dropdown",
        "options": ["Align", "GPS", "Log"],
        "title": "Chain Quality"
    },
    "Height": {
        "inputType": "text",
        "title": "Height"
    },
    "Northing": {
        "inputType": "text",
        "title": "Northing"
    },
    "Easting": {
        "inputType": "text",
        "title": "Easting"
    },
    "Elevation": {
        "inputType": "text",
        "title": "Elevation"
    },
    "Depth": {
        "inputType": "text",
        "title": "Depth"
    },
    "Adj_Elevation": {
        "inputType": "text",
        "title": "Adj Elevation"
    },
    "H_Perc": {
        "inputType": "text",
        "title": "H Perc"
    },
    "V_Perc": {
        "inputType": "text",
        "title": "V Perc"
    },
    "PDOP": {
        "inputType": "text",
        "title": "PDOP"
    },
    "Obtime": {
        "inputType": "text",
        "title": "Obtime"
    },
    "LSD": {
        "inputType": "text",
        "title": "LSD"
    },
    "Surveyor": {
        "inputType": "text",
        "title": "Surveyor",
        "disabled": true,
    },
    "Survey_Date": {
        "inputType": "text",
        "title": "Survey Date",
        "disabled": true,
    }
}

const AGMPlanningSchema = {
    "Site_Name": {
        "inputType": "text",
        "title": "Site Name",
        "required":  true

    },
    // "Real_Chain": {
    //     "inputType": "number",
    //     "title": "Real Chain (km)",
    //     "required":  true

    // },
    "Est_Chain": {
        "inputType": "number",
        "title": "Estimated Chain (km)",
        "required":  true,
        "readOnlyWhenLocked": true
    },
    "Est_Lat": {
        "inputType": "number",
        "title": "Estimated Latitude",
        "required":  true,
        "readOnlyWhenLocked": true
    },
    "Est_Lng": {
        "inputType": "number",
        "title": "Estimated Longitude",
        "required":  true,
        "readOnlyWhenLocked": true
    },
    "Planning_Notes": {
        "inputType": "text",
        "title": "Planning Notes"
    },
    "Address": {
        "inputType": "text",
        "title": "Address"
    },
    "Access_Notes": {
        "inputType": "text",
        "title": "Access Notes"
    }
}

const SubchainSchema = {
    "SC_Name": {
        "inputType": "text",
        "title": "Subchain",
        "required":  true
    },
    "OrderNum" : {
        "inputType": "number",
        "title": "Order",
        "readOnlyWhenLocked": true
    },
    "US_Site": {
        "inputType": "dropdown",
        "title": "Upstream site",
        "options": "agms", //lets table know to use fetched agms for options
        "required":  true, //required field
        "validation": (scLat, scLng, agmData) => scValidateUsAndDs(scLat, scLng, agmData),
        "readOnlyWhenLocked": true
    },
    "DS_Site": {
        "inputType": "dropdown",
        "title": "Downstream site",
        "options": "agms", //lets table know to use fetched agms for options
        "required":  true, //required field
        "validation": (scLat, scLng, agmData) => scValidateUsAndDs(scLat, scLng, agmData),
        "readOnlyWhenLocked": true
    },
    "Dist_To_US": {
        "inputType": "number",
        "title": "Distance to upstream",
        "calculation": (agms, subchains, scRow) => getUSDistance(agms, subchains, scRow),
        "disabled": true,
        "readOnlyWhenLocked": true
    },
    "Dist_To_DS": {
        "inputType": "number",
        "title": "Distance to downstream",
        "calculation": (agms, subchains, scRow) => getDSDistance(agms, subchains, scRow),
        "disabled": true,
        "readOnlyWhenLocked": true
    },
    "lat": {
        "inputType": "number",
        "title": "Latitude",
        "required":  true,
        "readOnlyWhenLocked": true
    },
    "lng": {
        "inputType": "number",
        "title": "Longitude",
        "required":  true,
        "readOnlyWhenLocked": true
    },
    "Elevation": {
        "inputType": "number",
        "title": "Elevation"
    },
    // do we need status?
    // "Status": {
    //     "inputType": "text",
    //     "title": "Subchain"
    // }
  }

  //will add notifications in v2
  const RunControlSchema = {
    "Run_Name":{
        "inputType": "text",
        "title": "Run name",
        "required":  true
    },
    "Low_Speed": {
        "inputType": "number",
        "title": "Low speed (km/h)",
        "required":  true
    },
    "High_Speed": {
        "inputType": "number",
        "title": "High speed (km/h)",
        "required":  true
    },
    "IsActive": {
        "inputType": "dropdown",
        "title": "Status",
        "options": ["Active", "Inactive"]
    },

  }

  //once texts are set up, add phone options back into table
  const SpeedNotificationSchema = {
    "Name":{
        "title": "Name",
    },
    "IsEmail": {
        "title": "Email",
        "inputType": "toggle-state",
    },
    "IsPhone": {
        "title": "Text",
        "inputType": "toggle-state",
    },
    "AltEmail": {
        "inputType": "text",
        "title": "Alternative Email",
    },
    "AltPhone": {
        "inputType": "text",
        "title": "Alternative phone",
    }

  }


export {AGMEditSchema, AGMPlanningSchema, SubchainSchema, RunControlSchema, SpeedNotificationSchema}